export default __webpack_public_path__ + "static/media/story-2.c2161f45.png";